import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c19245e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index-view mt-1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row align-items-md-stretch" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "text-center mt-4" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 my-3" }, null, -1))
const _hoisted_11 = { class: "col-md-12" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bg-blue-500 rounded px-2 inline py-1 text-white cursor-pointer hover:bg-gray-700",
  "data-bs-toggle": "modal",
  "data-bs-target": "#addFolderModal"
}, "+ Folder", -1))
const _hoisted_13 = { class: "mt-2 mb-12" }
const _hoisted_14 = { class: "min-h-8" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "ps-2 text-xl font-bold" }
const _hoisted_17 = {
  key: 1,
  class: "text-sm text-gray-500 ms-3 mt-3 px-3"
}
const _hoisted_18 = {
  ref: "updateFolderModal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#updateFolderModal"
}
const _hoisted_19 = {
  ref: "deleteFolderModal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteFolderModal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_ChevronUpIcon = _resolveComponent("ChevronUpIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_PencilSquareIcon = _resolveComponent("PencilSquareIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_WebsiteList = _resolveComponent("WebsiteList")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_AddWebsiteModal = _resolveComponent("AddWebsiteModal")!
  const _component_DeleteWebsiteModal = _resolveComponent("DeleteWebsiteModal")!
  const _component_UpdateWebsiteModal = _resolveComponent("UpdateWebsiteModal")!
  const _component_WebsiteAddedModal = _resolveComponent("WebsiteAddedModal")!
  const _component_AddFolderModal = _resolveComponent("AddFolderModal")!
  const _component_UpdateFolderModal = _resolveComponent("UpdateFolderModal")!
  const _component_DeleteFolderModal = _resolveComponent("DeleteFolderModal")!
  const _component_ViewWebsiteModal = _resolveComponent("ViewWebsiteModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["btn btn-outline-light mt-4", { 'text-black border': _ctx.websites.length >= _ctx.getPossibleWebsites }]),
              type: "button",
              "data-bs-toggle": "modal",
              "data-bs-target": "#addWebsiteModal",
              disabled: _ctx.websites.length >= _ctx.getPossibleWebsites
            }, "+ Add", 10, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("small", null, [
                _createElementVNode("i", _hoisted_8, [
                  _createTextVNode(_toDisplayString(_ctx.websites.length) + " from " + _toDisplayString(_ctx.getPossibleWebsites) + " website targets already used.", 1),
                  _hoisted_9,
                  _createTextVNode("You " + _toDisplayString(_ctx.websites.length < _ctx.getPossibleWebsites ? 'can'
                                        : 'have to') + " ", 1),
                  _createVNode(_component_router_link, { to: { name: 'payment' } }, {
                    default: _withCtx(() => [
                      _createTextVNode("upgrade")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" your plan to increase this limit.")
                ])
              ])
            ])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          (!_ctx.websitesLoaded)
            ? (_openBlock(), _createBlock(_component_loading_spinner, {
                key: 0,
                class: "mt-5 pt-5"
              }))
            : _createCommentVNode("", true),
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_draggable, {
              modelValue: _ctx.folders,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.folders) = $event))
            }, {
              item: _withCtx(({ element }) => [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "folder-header cursor-pointer border-b",
                    onClick: ($event: any) => (element.collapsed = !element.collapsed)
                  }, [
                    (element.collapsed)
                      ? (_openBlock(), _createBlock(_component_ChevronUpIcon, {
                          key: 0,
                          class: "h-7 w-7 -mt-1 text-black"
                        }))
                      : _createCommentVNode("", true),
                    (!element.collapsed)
                      ? (_openBlock(), _createBlock(_component_ChevronDownIcon, {
                          key: 1,
                          class: "h-7 w-7 -mt-1 text-black"
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(element.name), 1),
                    _createVNode(_component_PencilSquareIcon, {
                      class: "h-4 w-4 cursor-pointer -mt-1.5 ms-2 me-1",
                      onClick: _withModifiers(($event: any) => {_ctx.selectedFolder = element;_ctx.openModal('updateFolderModal')}, ["stop"])
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_TrashIcon, {
                      class: "h-4 w-4 cursor-pointer -mt-1.5",
                      onClick: _withModifiers(($event: any) => {_ctx.selectedFolder = element;_ctx.openModal('deleteFolderModal')}, ["stop"])
                    }, null, 8, ["onClick"])
                  ], 8, _hoisted_15),
                  (_ctx.websitesLoaded && !element.collapsed)
                    ? (_openBlock(), _createBlock(_component_WebsiteList, {
                        key: 0,
                        websites: element.websites,
                        class: "ps-4 mb-2",
                        "onUpdate:websites": ($event: any) => (element.websites = $event),
                        onSelectedWebsite: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedWebsite = $event)),
                        onSelectedDefaultDate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedDefaultDate = $event))
                      }, null, 8, ["websites", "onUpdate:websites"]))
                    : _createCommentVNode("", true),
                  (!element.websites.length && _ctx.websitesLoaded && !element.collapsed)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, "The folder is empty"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddWebsiteModal, {
      onAdded: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addedWebsite = $event))
    }),
    _createVNode(_component_DeleteWebsiteModal, { website: _ctx.selectedWebsite }, null, 8, ["website"]),
    _createVNode(_component_UpdateWebsiteModal, { website: _ctx.selectedWebsite }, null, 8, ["website"]),
    _createVNode(_component_WebsiteAddedModal, { addedWebsite: _ctx.addedWebsite }, null, 8, ["addedWebsite"]),
    _createVNode(_component_AddFolderModal),
    _createVNode(_component_UpdateFolderModal, { folder: _ctx.selectedFolder }, null, 8, ["folder"]),
    _createElementVNode("i", _hoisted_18, null, 512),
    _createVNode(_component_DeleteFolderModal, { folder: _ctx.selectedFolder }, null, 8, ["folder"]),
    _createElementVNode("i", _hoisted_19, null, 512),
    _createVNode(_component_ViewWebsiteModal, {
      website: _ctx.selectedWebsite,
      defaultDate: _ctx.selectedDefaultDate
    }, null, 8, ["website", "defaultDate"])
  ]))
}